 
export class TempFilterAction {
  static readonly type = '[TempFilterAction] TempFilterAction';

  constructor(public payload: any) {}
}